import GlossaryContent from "../../pages/glossary/Content";
import { uiIcons } from "../../assets/icons";
import ModalBase, { ModalType } from "../modals/ModalBase";
import { NavModalTrigger } from "@atlas-int/ui";
import { googleAnalyticsCustomEvent } from "../../sharedUtilities/analytics";

const GlossaryModalButton = ({
  menuOptionClassName,
  isNavigationBarOpen,
}: any) => {
  return (
    <NavModalTrigger
      icon={uiIcons.glossary}
      iconAlt="Glossary"
      label="Glossary"
      isNavOpen={isNavigationBarOpen}
      menuOptionClassName={menuOptionClassName}
      onOpen={() =>
        googleAnalyticsCustomEvent("leftnav", "click", "glossary", "explore")
      }
    >
      {({ isOpen, onToggle }) =>
        isOpen ? (
          <ModalBase
            modalType={ModalType.Glossary}
            toggleModal={onToggle}
          >
            <GlossaryContent />
          </ModalBase>
        ) : null
      }
    </NavModalTrigger>
  );
};

export default GlossaryModalButton;
